import { render, staticRenderFns } from "./AgeCard.vue?vue&type=template&id=2f1028af&scoped=true"
import script from "./AgeCard.vue?vue&type=script&lang=js"
export * from "./AgeCard.vue?vue&type=script&lang=js"
import style0 from "./AgeCard.vue?vue&type=style&index=0&id=2f1028af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1028af",
  null
  
)

export default component.exports